import { Box } from "@mui/material";
import styled from "styled-components";

const Shadow = styled(Box)`
  box-shadow: 0px 2.6px 3.6px -22px rgba(0, 0, 0, 0.038), 0px 7.1px 10px -22px rgba(0, 0, 0, 0.055),
    0px 17.2px 24.1px -22px rgba(0, 0, 0, 0.072), 0px 57px 80px -22px rgba(0, 0, 0, 0.11);
`;

export default Shadow;
